module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_7042.a3e50d2e.png";